import React from 'react';
import { Banner } from '@els/els-react--banner';

function AEMock() {
  return (
    <li className="u-els-padding-left-1o2">
      <Banner type="info" isVisible size="small">
        Using A&E mock
      </Banner>
    </li>
  );
}

export default AEMock;
